export default "__VITE_ASSET__DXFeUYm___"